import { Common } from '@thecvlb/design-system';

import { LINK_TO_MEMBERSHIP } from 'constants/externalLinks';

import { FailedLoginProps } from './failedLogin.types';

const FailedLogin: React.FC<FailedLoginProps> = ({ isOpen, onClose }) => {
  return (
    <Common.Modal
      close={() => onClose()}
      isOpen={isOpen}
      size="sm"
      title="We couldn’t find an account!"
    >
      <Common.Alert className="my-6" type="info" colorableBackground>
        We weren’t able to find an account with this email address. Please tap the button below to
        create a new account.
      </Common.Alert>
      <div className="flex justify-center gap-4 max-md:flex-col md:gap-2">
        <Common.Button
          color="blue"
          fullWidthOnMobile
          onClick={() => {
            window.open(LINK_TO_MEMBERSHIP, '_blank');
            onClose();
          }}
        >
          Sign up
        </Common.Button>
        <Common.Button
          color="white-alt"
          fullWidthOnMobile
          onClick={() => {
            onClose(true);
          }}
        >
          Try with a different email
        </Common.Button>
      </div>
    </Common.Modal>
  );
};

export default FailedLogin;
